import { memo } from 'react'
import Dropzone from 'react-dropzone'
import { Controller } from 'react-hook-form'

import s from './CustomDropzone.module.scss'

import { UploadIcon } from 'assets/icons/UploadIcon'

import { ControlsError } from 'components/UI/ControlsError/ControlsError'

interface Props {
  control: any
  name: string
  uploaded?: string | React.ReactElement
  noMediaTitle: React.ReactNode
  error: string | undefined
  wrapperStyles?: React.CSSProperties
  dropzoneStyles: React.CSSProperties
  iconWidth: number
  iconHeight: number
  noMediaFont?: number
  alignItems?: 'center' | 'flex-start'
  selfAlign?: 'center' | 'flex-start'
  testid?: string
}

export const CustomDropzone = memo((props: Props) => {
  const {
    control,
    name,
    uploaded = '',
    noMediaTitle,
    error,
    iconHeight,
    iconWidth,
    dropzoneStyles,
    noMediaFont,
    wrapperStyles,
    testid
  } = props

  return (
    <div style={wrapperStyles}>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, onBlur, value } }) => (
          <Dropzone onDrop={onChange} maxFiles={1} autoFocus>
            {({ getRootProps, getInputProps }) => (
              <div
                {...getRootProps()}
                className={`${s.dropzoneWrapper} ${error && s.errorBorder}`}
                style={dropzoneStyles}
              >
                <input {...getInputProps()} onBlur={onBlur} name={name} data-testid={testid}/>
                {!uploaded && !value?.length ? ( //if no preview from server and no dropped file displays "No Media"
                  <div className={s.noMedia}>
                    <UploadIcon style={{ width: iconWidth, height: iconHeight, opacity: 0.3, fill: '#fff' }} />
                    <div style={{ fontSize: noMediaFont }}>{noMediaTitle}</div>
                  </div>
                ) : value?.length && (typeof uploaded === 'string' || uploaded === null || uploaded === undefined) ? ( //if there is a value and uploaded string or none - display value as image or video
                  value[0]?.type?.includes('webm') || value[0]?.type?.includes('mp4') ? (
                    <video className={s.uploaded}>
                      <source src={URL.createObjectURL(value[0])} />
                    </video>
                  ) : (
                    <img src={URL.createObjectURL(value[0])} alt="" className={s.uploaded} />
                  )
                ) : typeof uploaded === 'string' ? ( // if uploaded string and no value dropped - displays preview from server
                  <img src={uploaded} className={s.uploaded} alt="" />
                ) : (
                  // if uploaded is reactNode - just render it
                  uploaded
                )}
              </div>
            )}
          </Dropzone>
        )}
      />
      {error && <ControlsError error={error} />}
    </div>
  )
})
